// SITEWISE VALUES TO READ

// These variables can be accessed by valuesSW.changeoverMins from App.js
export const labelMap = {
  0: "changeoverMins",
  1: "changeoverSeconds",
  2: "changeover",
  3: "DTActive",
  4: "EventsJSON",
  5: "speed",
  6: "currentMode",
  7: "productionCount",
  8: "warningActive",
  9: "materialT",
};

export const getStorkAssets = () => [
  {
    assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a", //  Stork

    properties: [
      { propertyId: "3f7504b4-aa75-4211-b730-fa9019d0d036" }, // 0 - Changeover_minutes
      { propertyId: "769505cf-96ad-4ac8-83c6-24f6e196cc99" }, // 1 - Changeover_seconds
      { propertyId: "26870bcd-4ad6-4321-b71b-c322d8b776e5" }, // 2 - ChangeoverActive
      { propertyId: "a4dab8fb-a107-493c-b282-726c78480823" }, // 3 - DowntimeAuto_Active
      { propertyId: "a1e3bd86-0809-4482-aeda-7d51c5157bdb" }, // 4 - EventsAuto_JSON
      { propertyId: "6e2ea4b1-5a71-4ebf-8ae4-0de1fac572de" }, // 5 - FillRate
      { propertyId: "8179e9cb-2901-4d9e-9927-c865fe62da04" }, // 6 - Mode
      { propertyId: "4bb4971e-1903-46db-9cca-22fa68782024" }, // 7 - ProductionCount
      { propertyId: "e8496e71-f7ec-46c9-9961-d099e47a027e" }, // 8 - WarningAuto_Active
    ],
  },
  {
    assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843", //  Line S

    properties: [
      { propertyId: "cba8600b-e20a-4a73-8390-a3400ed245d7" }, // 9 - Material Code 
    
    ],
  },
];

// SITEWISE VALUES TO WRITE

const propertyMap = {
  startShiftTime: {
    // string
    assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
    propertyId: "73c6fd17-d1bc-4a2e-9db6-2ef78c1c0748",
  },
  endShiftTime: {
    // string
    assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
    propertyId: "354ff583-e8aa-4d14-9faa-4ee322fae63b",
  },
  logsSW: {
    // string
    assetId: "7b5d659a-a8b2-456f-9152-24526534158e",
    propertyId: "61fd33f6-6e60-4bf5-ae1d-098d6dd987dd",
  },
  DowntimeManualActive: {
    // boolean
    assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a",
    propertyId: "c42b4a5b-b6ba-43ba-b084-43847466ce08",
  },
  DowntimeManualCode: {
    // integer
    assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a",
    propertyId: "9d17e271-dfc1-46c7-8ae4-74d6b1642001",
  },
  DowntimeManualComment: {
    // string
    assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a",
    propertyId: "99eb4764-8871-4c3a-a05b-b3b19193a0eb",
  },
  Shift: {
    // integer
    assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
    propertyId: "f952f560-ee27-47cc-8fde-3c82b466ff8c",
  },
};

// Returns values to write for manual downtime entries. First entry is 1 ms before the downtime start time and value is zero or false, then second entry is the actual downtime
// and third entry is when downtime is finished and value is zero or false again.
// There are 9 entries in total. 3 entries for each measurement: downtimeManualActive, downtimeManualCode and downtimeManualComment.
// The function in App.js actually sends the command with these entries.
export const buildEntriesDT = (values) => {
  const entryTime = Date.now();

  const dtStartEpoch = Math.floor(new Date(values.startTime).getTime() / 1000);
  const dtEndEpoch = Math.floor(new Date(values.endTime).getTime() / 1000);

  const valueCodeInt = parseInt(values.code.split(":")[0], 10);
  const valueComment = values.comment;

  const points = [
    { label: "start", time: dtStartEpoch - 1 },
    { label: "during", time: dtStartEpoch },
    { label: "end", time: dtEndEpoch },
  ];

  const entryDefs = [
    {
      key: "active",
      property: propertyMap.DowntimeManualActive,
      values: [false, true, false],
      type: "booleanValue",
    },
    {
      key: "code",
      property: propertyMap.DowntimeManualCode,
      values: [0, valueCodeInt, 0],
      type: "integerValue",
    },
    {
      key: "comment",
      property: propertyMap.DowntimeManualComment,
      values: ["", valueComment, ""],
      type: "stringValue",
    },
  ];

  const downtimeEntries = [];

  entryDefs.forEach(({ key, property, values, type }) => {
    values.forEach((val, idx) => {
      downtimeEntries.push({
        entryId: `${key}-${points[idx].label}-${entryTime}`,
        assetId: property.assetId,
        propertyId: property.propertyId,
        propertyValues: [
          {
            value: { [type]: val },
            timestamp: { timeInSeconds: points[idx].time },
            quality: "GOOD",
          },
        ],
      });
    });
  });

  return downtimeEntries;
};

// The entries for Shift measurement that is used in Power BI. If startShift value is received, then it sends the entry with a timestamp of 1 ms before starttime and value 0.
// Then the second entry is the starttime and shift value 1 (day shift) or 2 (night shift). If the endstart is received, then it sends the entry with a timestamp of endtime and value 0
export const buildEntriesShift = (values) => {
  const entryTime = Date.now();

  const downtimeEntries = [];
  const property = propertyMap["Shift"];

  if (values.startShiftTime) {
    const dtStartEpoch = Math.floor(
      new Date(values.startShiftTime).getTime() / 1000
    );
    const hour = new Date(values.startShiftTime).getHours();
    const shiftValue = hour >= 5 && hour < 17 ? 1 : 2;

    downtimeEntries.push({
      entryId: `Shift-${entryTime}-before`,
      assetId: property.assetId,
      propertyId: property.propertyId,
      propertyValues: [
        {
          value: { integerValue: 0 },
          timestamp: { timeInSeconds: dtStartEpoch - 1 },
          quality: "GOOD",
        },
      ],
    });

    downtimeEntries.push({
      entryId: `Shift-${entryTime}-start`,
      assetId: property.assetId,
      propertyId: property.propertyId,
      propertyValues: [
        {
          value: { integerValue: shiftValue },
          timestamp: { timeInSeconds: dtStartEpoch },
          quality: "GOOD",
        },
      ],
    });
  }

  if (values.endShiftTime) {
    const dtEndEpoch = Math.floor(
      new Date(values.endShiftTime).getTime() / 1000
    );

    downtimeEntries.push({
      entryId: `Shift-${entryTime}-end`,
      assetId: property.assetId,
      propertyId: property.propertyId,
      propertyValues: [
        {
          value: { integerValue: 0 },
          timestamp: { timeInSeconds: dtEndEpoch },
          quality: "GOOD",
        },
      ],
    });
  }

  return downtimeEntries;
};

// It builds an entry for any value from propertyMap. It sends a current timestamp. It used for shift measurements that are used in the app.
export const buildEntries = (values) => {
  const now = Math.floor(Date.now() / 1000);
  const entryTime = Date.now(); // stable for entryId

  return Object.entries(values)
    .map(([key, value]) => {
      const map = propertyMap[key];

      if (!map) {
        console.warn(`Unmapped field: ${key}`);
        return null;
      }

      let valuePayload;
      if (typeof value === "number") {
        valuePayload = Number.isInteger(value)
          ? { integerValue: value }
          : { doubleValue: value };
      } else {
        valuePayload = { stringValue: value };
      }

      return {
        entryId: `${key}-${entryTime}`, // use fixed timestamp here
        assetId: map.assetId,
        propertyId: map.propertyId,
        propertyValues: [
          {
            value: valuePayload,
            timestamp: { timeInSeconds: now }, // same timestamp for all
            quality: "GOOD",
          },
        ],
      };
    })
    .filter(Boolean);
};
